import { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState(() => {
    try {
      const saved = localStorage.getItem('cart');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cartItems));
  }, [cartItems]);

  // qty = optional quantity (default 1)
  const addToCart = (product, variant, qty = 1) => {
    setCartItems(prev => {
      const key = `${product.id}-${variant.size}-${variant.color || ''}`;
      const existing = prev.find(item => item.key === key);

      if (existing) {
        return prev.map(item =>
          item.key === key
            ? { ...item, quantity: item.quantity + qty }
            : item
        );
      }

      return [...prev, {
        key,
        productId: product.id,
        name: product.name,
        price: variant.price || product.basePrice,
        size: variant.size,
        color: variant.color || '',
        image: product.imageUrls?.[0] || '',
        quantity: qty,
        stock: variant.stock || 0,
      }];
    });
  };

  const updateQuantity = (itemKey, newQuantity) => {
    setCartItems(prev =>
      prev.map(item =>
        item.key === itemKey
          ? { ...item, quantity: Math.max(1, newQuantity) }
          : item
      )
    );
  };

  const removeFromCart = (itemKey) => {
    setCartItems(prev => prev.filter(item => item.key !== itemKey));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const totalPrice = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  return (
    <CartContext.Provider value={{
      cartItems,
      addToCart,
      removeFromCart,
      updateQuantity,
      clearCart,
      totalPrice,
    }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}